<div class="flex flex-row align-items-center">
   <span class="text-500 mr-2">{{ filter.filter.label }}</span>

   <div class="text-600 font-semibold flex flex-row gap-2 align-items-center">
      <ng-container *ngIf="operationLabel">
         <span>{{ operationLabel }}</span>
      </ng-container>

      <ng-container *ngFor="let name of workflowNames.slice(0, 2)">
         <p-chip [label]="name"></p-chip>
      </ng-container>

      <ng-container *ngIf="workflowNames.length > 2">
         <span>+ {{ workflowNames.length - 2 }} {{ 'DATA.COMMON.GENERIC.MORE' | translate }}</span>
      </ng-container>
   </div>
</div>
